(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl--announcement-banner-5"] && !Shopify.designMode) return;
  try {
    
const duplicateBannerContent = () => {
  const parents = document.querySelectorAll('[banner-data="parent"]');
  
  if (parents.length === 0) return;
  
  for (const parent of parents) {
    const child = parent.querySelector('[banner-data="duplicate"]');
    if (!child) continue;
    
    if (parent.children.length > 1) continue;
    
    const duplicate = child.cloneNode(true);
    parent.appendChild(duplicate);
  }
};

// Measure the banner's real height and expose it as a CSS variable so other
// elements (like the sticky header) can stack below it instead of overlapping.
const setAnnouncementBannerHeightVar = () => {
  const banner = document.querySelector('.pl--announcement-banner-5__bg');
  if (!banner) return;
  const height = banner.offsetHeight;
  document.documentElement.style.setProperty('--announcement-banner-height', height + 'px');
};

const initAnnouncementBanner = () => {
  duplicateBannerContent();
  setAnnouncementBannerHeightVar();

  const banner = document.querySelector('.pl--announcement-banner-5__bg');
  if (banner && typeof ResizeObserver !== 'undefined') {
    const resizeObserver = new ResizeObserver(setAnnouncementBannerHeightVar);
    resizeObserver.observe(banner);
  }
};

// Handle initial load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAnnouncementBanner);
} else {
  initAnnouncementBanner();
}

window.addEventListener('resize', setAnnouncementBannerHeightVar);

// Handle theme editor changes
document.addEventListener('shopify:section:load', initAnnouncementBanner);
document.addEventListener('shopify:section:reorder', setAnnouncementBannerHeightVar);

  } catch(e) { console.error(e); }
})();
})();
